const getBalance = state => state.auth.user.balance;

export default getBalance;
